// src/components/Directory/ListingForm.js

import React, { useState } from 'react';
// ...diğer importlar aynı kalacak (addDoc, ref, uploadBytes, vs.)
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from '../../config/firebaseConfig';


const categories = ["Agent", "Authors", "Distributors", "Editors", "Illustrators", "Marketing", "Platforms", "Printers", "Publishers", "Stockists"].sort();

const ListingForm = ({ onFormSubmit }) => {
    const initialState = {
        category: '', name: '', email: '', phone: '', address: '', description: '',
    };
    // ...diğer state'ler (formData, companyPhoto, vs.) aynı kalacak
    const [formData, setFormData] = useState(initialState);
    const [companyPhoto, setCompanyPhoto] = useState(null);
    const [dataConsent, setDataConsent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleFormChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setCompanyPhoto(e.target.files[0]);
        }
    };
    
    // handleSubmit fonksiyonu aynı kalacak
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!companyPhoto || !formData.category || !formData.name || !dataConsent) {
            setError('Please fill all required fields (*) and give your consent.');
            return;
        }

        setLoading(true);
        try {
            const storageRef = ref(storage, `logos/${Date.now()}_${companyPhoto.name}`);
            const snapshot = await uploadBytes(storageRef, companyPhoto);
            const photoURL = await getDownloadURL(snapshot.ref);

            await addDoc(collection(db, "professionals"), {
                ...formData,
                photoURL,
                consentGiven: dataConsent,
                status: 'pending',
                createdAt: new Date()
            });

            setSuccess('Thank you for your submission! Your listing will be reviewed shortly.');
            setFormData(initialState);
            setCompanyPhoto(null);
            setDataConsent(false);
            e.target.reset();
            // Form gönderildikten 2 saniye sonra modal'ı kapat
            setTimeout(() => {
                onFormSubmit();
            }, 2000);
            
        } catch (err) {
            setError('An error occurred. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    // Başarı mesajı gösteriliyorsa formu gizle
    if (success) {
        return <div className="alert alert-success text-center">{success}</div>;
    }

    return (
        <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}
            
            <div className="row">
                <div className="col-12 mb-3">
                    <label htmlFor="companyPhoto" className="form-label">Company Photo / Logo / Profile Photo <span className="text-danger">*</span></label>
                    <input type="file" className="form-control" id="companyPhoto" onChange={handleFileChange} accept="image/*" required />
                </div>

                <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label">Name / Company <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="name" name="name" value={formData.name} onChange={handleFormChange} required />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="category" className="form-label">Category <span className="text-danger">*</span></label>
                    <select className="form-select" id="category" name="category" value={formData.category} onChange={handleFormChange} required>
                        <option value="">Select...</option>
                        {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                </div>

                <div className="col-md-6 mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleFormChange} />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input type="tel" className="form-control" id="phone" name="phone" value={formData.phone} onChange={handleFormChange} />
                </div>

                <div className="col-12 mb-3">
                    <label htmlFor="description" className="form-label">Short Description</label>
                    <textarea className="form-control" id="description" name="description" rows="3" placeholder="Briefly describe your services..." value={formData.description} onChange={handleFormChange}></textarea>
                </div>

                <div className="col-12 mb-3">
                    <label htmlFor="address" className="form-label">Address</label>
                    <textarea className="form-control" id="address" name="address" rows="2" value={formData.address} onChange={handleFormChange}></textarea>
                </div>
            </div>

            <div className="form-check mt-2 mb-4">
                <input className="form-check-input" type="checkbox" id="dataConsentCheck" checked={dataConsent} onChange={(e) => setDataConsent(e.target.checked)} required />
                <label className="form-check-label small" htmlFor="dataConsentCheck">
                    I consent to the personal data I have provided being publicly shared in this directory. <span className="text-danger">*</span>
                </label>
            </div>

            <div className="d-grid">
                <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Submitting...
                        </>
                    ) : 'Submit My Listing'}
                </button>
            </div>
        </form>
    );
};

export default ListingForm;